import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.667 18.6a1.5 1.5 0 0 1-.692-.175 1.45 1.45 0 0 1-.767-1.283v-1.184C2.692 15.7 1.042 13.85 1.042 11.2v-5c0-2.867 1.925-4.792 4.791-4.792h8.334c2.866 0 4.791 1.925 4.791 4.792v5c0 2.867-1.925 4.792-4.791 4.792h-3.142l-3.55 2.366a1.5 1.5 0 0 1-.808.242M5.833 2.65c-2.15 0-3.541 1.392-3.541 3.542v5c0 2.15 1.391 3.541 3.541 3.541a.63.63 0 0 1 .625.625v1.775c0 .109.067.159.109.184s.125.05.216-.009l3.709-2.466a.64.64 0 0 1 .35-.109h3.333c2.15 0 3.542-1.391 3.542-3.541v-5c0-2.15-1.392-3.542-3.542-3.542z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 10.092a.63.63 0 0 1-.625-.625v-.175c0-.967.708-1.442.975-1.625.308-.209.408-.35.408-.567A.76.76 0 0 0 10 6.342a.76.76 0 0 0-.758.758.63.63 0 0 1-.625.625.63.63 0 0 1-.625-.625 2.01 2.01 0 0 1 4.016 0c0 .95-.7 1.425-.958 1.6-.325.217-.425.358-.425.592v.175c0 .35-.283.625-.625.625"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": ".833",
      d: "M10 11.334c.111 0 .208.096.208.208a.207.207 0 0 1-.208.208.207.207 0 0 1-.208-.208c0-.112.096-.208.208-.208Z"
    }, null, -1)
  ]))]))
}
export default { render: render }